import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {BLUE} from '../constants/index';


const CustomButton = (props) => {

  let {
    label = 'Continue',
    type = 'submit',
    fullWidth = false,
    backgroundColor = BLUE,
    labelColor='#FFF',
    style={},
    buttonStyle={},
    disabled=false,
    disabledLabelColor='grey'
  } = props

  style = Object.assign({
    width: '258px',
  }, style)

  buttonStyle = Object.assign({
    borderRadius:'5px',
    backgroundColor:BLUE
  }, buttonStyle)


  return (
    <div className='submit-button'>
      <RaisedButton
        type={type}
        label={label}
        fullWidth={fullWidth}
        backgroundColor={backgroundColor}
        labelColor={labelColor}
        style={style}
        buttonStyle={buttonStyle}
        disabled={disabled}
        disabledLabelColor={disabledLabelColor}
      />
    </div>
  )
}

export default CustomButton;




// WEBPACK FOOTER //
// ./src/components/CustomButton.js